import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ChevronRight, AlertTriangle } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function IncidenciasLista() {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");

    useEffect(() => {
        api.get("/incidents/summary")
            .then((r) => setRows(r.data || []))
            .catch(() => toast.error("Error cargando incidencias"))
            .finally(() => setLoading(false));
    }, []);

    const filtered = rows.filter((r) => (r.student_name || "").toLowerCase().includes(search.toLowerCase()));

    return (
        <div className="p-6 md:p-10 fade-in min-h-screen max-w-2xl mx-auto">
            <h1 className="text-2xl font-semibold mb-1 inline-flex items-center gap-2"><AlertTriangle size={22} className="text-edu-navy" /> Incidencias</h1>
            <p className="text-edu-muted mb-6">Cuántas incidencias tiene cada alumno del colegio.</p>

            <div className="relative mb-4">
                <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-edu-muted" />
                <input
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Buscar alumno por nombre…"
                    className="edu-input w-full pl-9"
                    autoFocus
                />
            </div>

            {loading ? (
                <p className="text-sm text-edu-muted">Cargando…</p>
            ) : filtered.length === 0 ? (
                <div className="edu-card p-8 text-center text-edu-muted">Ningún alumno tiene incidencias registradas todavía.</div>
            ) : (
                <div className="space-y-2">
                    {filtered.map((r) => (
                        <button
                            key={r.student_id}
                            onClick={() => navigate(`/admin/incidencias/${r.student_id}`)}
                            className="edu-card w-full text-left p-4 hover:bg-edu-soft transition-colors flex items-center justify-between gap-3"
                        >
                            <div>
                                <p className="font-medium text-sm">{r.student_name}</p>
                                <p className="text-xs text-edu-muted">{r.student_grade}</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <span className="edu-pill bg-amber-100 text-amber-800 text-xs px-2.5 py-1 rounded-full">{r.count} incidencia{r.count !== 1 ? "s" : ""}</span>
                                <ChevronRight size={16} className="text-edu-muted" />
                            </div>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
